<template>
  <p class="a-price-table-header">
    <slot>{{ title }}</slot>
  </p>
</template>

<script>
import { mapModifiers } from '@/libs/component';

export default {
  name: 'a-price-table-header',
  props: {
    title: {
      type: String,
      default: null,
    },
  },
};
</script>
